var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLogoBlue(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 1207.38,
    height: 1207.38,
    viewBox: "0 0 1207.38 1207.38",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_151",
    "data-name": "Path 151",
    d: "M0-1207.38H1207.38V0H0Z",
    transform: "translate(0 1207.38)"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "logoBlue",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_116",
    "data-name": "Path 116",
    d: "M0,0C-298.486,0-540.457,241.971-540.457,540.457S-298.486,1080.91,0,1080.91,540.457,838.942,540.457,540.457,298.486,0,0,0M0,45A492.317,492.317,0,0,1,192.84,83.917a493.853,493.853,0,0,1,157.5,106.2,493.867,493.867,0,0,1,106.2,157.5,497.235,497.235,0,0,1,0,385.68,493.849,493.849,0,0,1-106.2,157.5A493.836,493.836,0,0,1,192.84,997,492.3,492.3,0,0,1,0,1035.91,492.3,492.3,0,0,1-192.84,997a493.862,493.862,0,0,1-157.5-106.2,493.863,493.863,0,0,1-106.2-157.5,492.309,492.309,0,0,1-38.917-192.839A492.322,492.322,0,0,1-456.54,347.616a493.881,493.881,0,0,1,106.2-157.5,493.88,493.88,0,0,1,157.5-106.2A492.317,492.317,0,0,1,0,45",
    transform: "translate(604.146 63.234)",
    fill: "#004b94"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_117",
    "data-name": "Path 117",
    d: "M0,0A440.966,440.966,0,0,1-123.04-306.4,441.609,441.609,0,0,1-5.12-607.362l7.337,6.795A431.634,431.634,0,0,0-113.04-306.4,431.011,431.011,0,0,0,7.222-6.918Z",
    transform: "translate(284.165 910.09)",
    fill: "#004b94"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_118",
    "data-name": "Path 118",
    d: "M0,0-7.223-6.918A431.008,431.008,0,0,0,113.04-306.4,431.641,431.641,0,0,0-2.217-600.567l7.336-6.795A441.606,441.606,0,0,1,123.04-306.4,440.969,440.969,0,0,1,0,0",
    transform: "translate(924.127 910.09)",
    fill: "#004b94"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_119",
    "data-name": "Path 119",
    d: "M0,0,23.294,54.738,11.181,59.893,2.305,39.036a22.528,22.528,0,0,1-12.526,13.29c-17.941,7.635-31.438-.067-38.531-16.734L-60.187,8.723l12.206-5.194L-36.548,30.4c4.3,10.11,11.529,15.21,21.639,10.909,8.926-3.8,12.648-10.977,9.424-20.577L-12.114,5.155Z",
    transform: "translate(450.774 170.036)",
    fill: "#004b94"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_120",
    "data-name": "Path 120",
    d: "M0,0,.34,1.749-12.776,4.3l-.284-1.457c-.87-4.47-4.565-6.876-9.132-5.988L-52.6,2.777l1.74,8.939L-63.881,14.25l-5.448-27.982,13.019-2.534,1.645,8.453c19.948-5.8,33.288-21.707,30.641-35.309-1.911-9.813-11.133-13.16-21-11.542C-55.6-53.01-62.1-46-60.034-35.406l.34,1.748-13.02,2.535-.434-2.235c-3.406-17.488,6.867-29.472,25.462-32.889,18.323-3.264,33.642,3.939,36.837,20.359,2.837,14.574-5.538,27.5-17,33.36l5.926-1.154C-9.488-16.1-2.308-11.853,0,0",
    transform: "translate(562.201 202.781)",
    fill: "#004b94"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_121",
    "data-name": "Path 121",
    d: "M0,0-.5,16.225c-.555,18.2-12.374,29.133-30.974,28.567-18.8-.572-30.129-12.207-29.575-30.411l1.061-34.825L-76.7-20.953l.352-11.575,30.076.916-1.413,46.4C-48.021,25.771-41.493,32.5-31.1,32.821c10.19.31,16.915-5.922,17.252-17l.495-16.226Z",
    transform: "translate(652.362 160.422)",
    fill: "#004b94"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_122",
    "data-name": "Path 122",
    d: "M0,0-8.849-12.836c-6.8,5.45-16.045,7.063-26.655,4.208-18.162-4.885-26.51-18.816-21.779-36.405l12.059-44.832,12.9,3.472L-44.378-41.562C-47.232-30.952-42.43-22.9-32.394-20.194c9.847,2.648,17.828-1.868,20.707-12.574L.373-77.6l12.9,3.471L1.218-29.3a33.919,33.919,0,0,1-2.546,6.8L9.369-7.013Z",
    transform: "translate(740.548 226.58)",
    fill: "#004b94"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_123",
    "data-name": "Path 123",
    d: "M0,0-27.548,52.727l-11.669-6.1,10.5-20.091a22.526,22.526,0,0,1-18.219-1.254c-17.284-9.029-19.888-24.35-11.5-40.4L-44.919-41l11.757,6.143L-46.684-8.978C-51.771.761-51.131,9.583-41.393,14.67c8.6,4.492,16.508,2.818,21.886-5.765l7.837-15Z",
    transform: "translate(842.434 210.166)",
    fill: "#004b94"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_124",
    "data-name": "Path 124",
    d: "M0,0C-211.146,0-382.314,171.168-382.314,382.314S-211.146,764.629,0,764.629,382.315,593.461,382.315,382.314,211.146,0,0,0M0,20A360.036,360.036,0,0,1,141.023,48.464,361.11,361.11,0,0,1,256.2,126.119,361.114,361.114,0,0,1,333.85,241.292a363.565,363.565,0,0,1,0,282.046A361.132,361.132,0,0,1,256.2,638.51a361.143,361.143,0,0,1-115.172,77.655A360.018,360.018,0,0,1,0,744.629a360.018,360.018,0,0,1-141.023-28.464A361.143,361.143,0,0,1-256.2,638.51,361.132,361.132,0,0,1-333.85,523.338a360.023,360.023,0,0,1-28.464-141.024A360.013,360.013,0,0,1-333.85,241.292,361.114,361.114,0,0,1-256.2,126.119,361.11,361.11,0,0,1-141.023,48.464,360.036,360.036,0,0,1,0,20",
    transform: "translate(604.146 221.376)",
    fill: "#004b94"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_125",
    "data-name": "Path 125",
    d: "M0,0A48.364,48.364,0,0,0,0,96.728,48.364,48.364,0,0,0,48.364,48.364,48.364,48.364,0,0,0,0,0M0,15A33.4,33.4,0,0,1,33.364,48.364,33.4,33.4,0,0,1,0,81.728,33.364,33.364,0,0,1,0,15",
    transform: "translate(604.287 306.128)",
    fill: "#004b94"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_126",
    "data-name": "Path 126",
    d: "M0,0A48.364,48.364,0,0,0,0,96.728,48.364,48.364,0,0,0,48.364,48.364,48.364,48.364,0,0,0,0,0M0,15A33.4,33.4,0,0,1,33.364,48.364,33.4,33.4,0,0,1,0,81.728,33.4,33.4,0,0,1-33.364,48.364,33.4,33.4,0,0,1,0,15",
    transform: "translate(604.287 810.26)",
    fill: "#004b94"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_127",
    "data-name": "Path 127",
    d: "M0,0A48.212,48.212,0,0,0-34.2,14.166a48.365,48.365,0,0,0,0,68.4A48.215,48.215,0,0,0,0,96.728,48.217,48.217,0,0,0,34.2,82.563a48.365,48.365,0,0,0,0-68.4A48.214,48.214,0,0,0,0,0M0,15a33.147,33.147,0,0,1,23.592,9.772,33.364,33.364,0,0,1,0,47.184A33.147,33.147,0,0,1,0,81.728a33.149,33.149,0,0,1-23.592-9.772,33.149,33.149,0,0,1-9.772-23.592,33.149,33.149,0,0,1,9.772-23.592A33.149,33.149,0,0,1,0,15",
    transform: "translate(423.12 377.028)",
    fill: "#004b94"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_128",
    "data-name": "Path 128",
    d: "M0,0A48.214,48.214,0,0,0-34.2,14.166a48.363,48.363,0,0,0,0,68.4A48.213,48.213,0,0,0,0,96.728,48.213,48.213,0,0,0,34.2,82.563a48.363,48.363,0,0,0,0-68.4A48.214,48.214,0,0,0,0,0M0,15a33.149,33.149,0,0,1,23.592,9.772,33.4,33.4,0,0,1,0,47.184A33.145,33.145,0,0,1,0,81.728a33.145,33.145,0,0,1-23.592-9.772,33.4,33.4,0,0,1,0-47.184A33.149,33.149,0,0,1,0,15",
    transform: "translate(785.453 739.36)",
    fill: "#004b94"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_129",
    "data-name": "Path 129",
    d: "M0,0A48.364,48.364,0,0,0-48.364,48.364,48.365,48.365,0,0,0,0,96.728,48.364,48.364,0,0,0,48.364,48.364,48.364,48.364,0,0,0,0,0M0,15H0A33.4,33.4,0,0,1,33.364,48.364,33.4,33.4,0,0,1,0,81.728,33.364,33.364,0,0,1,0,15",
    transform: "translate(352.221 558.194)",
    fill: "#004b94"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_130",
    "data-name": "Path 130",
    d: "M0,0A48.363,48.363,0,0,0-48.364,48.363,48.364,48.364,0,0,0,0,96.728,48.364,48.364,0,0,0,48.364,48.363,48.363,48.363,0,0,0,0,0M0,15A33.4,33.4,0,0,1,33.364,48.363,33.4,33.4,0,0,1,0,81.728,33.4,33.4,0,0,1-33.364,48.363,33.4,33.4,0,0,1,0,15",
    transform: "translate(856.353 558.194)",
    fill: "#004b94"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_131",
    "data-name": "Path 131",
    d: "M0,0A48.216,48.216,0,0,0-34.2,14.166a48.365,48.365,0,0,0,0,68.4A48.216,48.216,0,0,0,0,96.729,48.218,48.218,0,0,0,34.2,82.563a48.365,48.365,0,0,0,0-68.4A48.218,48.218,0,0,0,0,0M0,15a33.147,33.147,0,0,1,23.592,9.772,33.364,33.364,0,0,1,0,47.184A33.143,33.143,0,0,1,0,81.728a33.141,33.141,0,0,1-23.591-9.772,33.146,33.146,0,0,1-9.773-23.592,33.146,33.146,0,0,1,9.773-23.592A33.145,33.145,0,0,1,0,15",
    transform: "translate(423.12 739.36)",
    fill: "#004b94"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_132",
    "data-name": "Path 132",
    d: "M0,0A48.21,48.21,0,0,0-34.2,14.166a48.363,48.363,0,0,0,0,68.4A48.213,48.213,0,0,0,0,96.728,48.213,48.213,0,0,0,34.2,82.563a48.363,48.363,0,0,0,0-68.4A48.21,48.21,0,0,0,0,0M0,15a33.149,33.149,0,0,1,23.592,9.772,33.367,33.367,0,0,1,0,47.184A33.149,33.149,0,0,1,0,81.728a33.149,33.149,0,0,1-23.592-9.772,33.145,33.145,0,0,1-9.772-23.592,33.145,33.145,0,0,1,9.772-23.592A33.149,33.149,0,0,1,0,15",
    transform: "translate(785.453 377.028)",
    fill: "#004b94"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_133",
    "data-name": "Path 133",
    d: "M539.293-737.79H467.319v71.974h71.974Zm-15,56.974H482.319V-722.79h41.974Z",
    transform: "translate(0 1207.38)",
    fill: "#004b94"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_134",
    "data-name": "Path 134",
    d: "M741.631-535.451H669.657v71.974h71.974Zm-15,56.973H684.657v-41.974h41.974Z",
    transform: "translate(0 1207.38)",
    fill: "#004b94"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_135",
    "data-name": "Path 135",
    d: "M0,0-50.894,50.893,0,101.787,50.893,50.893ZM0,21.213l29.68,29.68L0,80.574-29.681,50.893Z",
    transform: "translate(461.401 555.853)",
    fill: "#004b94"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_136",
    "data-name": "Path 136",
    d: "M0,0-50.894,50.893,0,101.787,50.894,50.893ZM0,21.213l29.681,29.68L0,80.574-29.681,50.893Z",
    transform: "translate(747.55 555.853)",
    fill: "#004b94"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_137",
    "data-name": "Path 137",
    d: "M0,0-50.894,50.894,0,101.787,50.893,50.894ZM0,21.213,29.68,50.894,0,80.574l-29.68-29.68Z",
    transform: "translate(604.475 698.928)",
    fill: "#004b94"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_138",
    "data-name": "Path 138",
    d: "M0,0-50.894,50.894,0,101.787,50.893,50.894ZM0,21.213,29.68,50.894,0,80.574l-29.68-29.68Z",
    transform: "translate(604.475 412.778)",
    fill: "#004b94"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_139",
    "data-name": "Path 139",
    d: "M539.293-535.451H467.319v71.975h71.974Zm-15,56.974H482.319v-41.975h41.974Z",
    transform: "translate(0 1207.38)",
    fill: "#004b94"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_140",
    "data-name": "Path 140",
    d: "M741.631-737.79H669.657v71.974h71.974Zm-15,56.974H684.657V-722.79h41.974Z",
    transform: "translate(0 1207.38)",
    fill: "#004b94"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_141",
    "data-name": "Path 141",
    d: "M0,0A9.58,9.58,0,0,1-8.731,2.429L-53.3-6.823l44.572-9.252A9.58,9.58,0,0,1,0-13.646,9.615,9.615,0,0,1,2.827-6.823,9.615,9.615,0,0,1,0,0M-14.458,34.908a9.617,9.617,0,0,1-6.824,2.825,9.582,9.582,0,0,1-7.892-4.456L-54.148-4.782l38.059,24.974a9.581,9.581,0,0,1,4.456,7.892,9.617,9.617,0,0,1-2.825,6.824M-49.365,49.366a9.617,9.617,0,0,1-6.824,2.827,9.617,9.617,0,0,1-6.824-2.827,9.581,9.581,0,0,1-2.428-8.731l9.252-44.572,9.251,44.572a9.578,9.578,0,0,1-2.427,8.731M-83.207,33.283a9.581,9.581,0,0,1-7.887,4.45,9.617,9.617,0,0,1-6.826-2.825,9.606,9.606,0,0,1-2.713-5.346,9.638,9.638,0,0,1,4.422-9.414l37.879-24.71ZM-112.377,0a9.616,9.616,0,0,1-2.829-6.825,9.6,9.6,0,0,1,1.862-5.7,9.642,9.642,0,0,1,9.783-3.531L-59.3-6.739l-44.35,9.171A9.582,9.582,0,0,1-112.377,0M-97.92-48.554a9.6,9.6,0,0,1,5.346-2.713,9.643,9.643,0,0,1,9.414,4.422l24.71,37.88L-96.295-33.841a9.583,9.583,0,0,1-4.451-7.888,9.616,9.616,0,0,1,2.826-6.825m34.906-14.457a9.617,9.617,0,0,1,6.825-2.828,9.608,9.608,0,0,1,5.7,1.861,9.639,9.639,0,0,1,3.53,9.783L-56.273-9.937l-9.171-44.35a9.583,9.583,0,0,1,2.43-8.724m33.84,16.088a9.583,9.583,0,0,1,7.892-4.457,9.622,9.622,0,0,1,6.824,2.826,9.615,9.615,0,0,1,2.825,6.824,9.579,9.579,0,0,1-4.456,7.891L-54.148-8.864ZM17.782-6.838A24.628,24.628,0,0,0,.516-30.339,24.629,24.629,0,0,0-3.893-59.165,24.538,24.538,0,0,0-21.3-66.375a24.618,24.618,0,0,0-11.419,2.8,24.627,24.627,0,0,0-23.5-17.266,24.627,24.627,0,0,0-23.5,17.266,24.618,24.618,0,0,0-11.419-2.8,24.54,24.54,0,0,0-17.407,7.21,24.628,24.628,0,0,0-4.408,28.826,24.629,24.629,0,0,0-17.267,23.5,24.63,24.63,0,0,0,17.267,23.5,24.629,24.629,0,0,0,4.408,28.826A24.54,24.54,0,0,0-91.139,52.7,24.6,24.6,0,0,0-79.72,49.9a24.627,24.627,0,0,0,23.5,17.267A24.626,24.626,0,0,0-32.719,49.9,24.6,24.6,0,0,0-21.3,52.7a24.538,24.538,0,0,0,17.407-7.21A24.629,24.629,0,0,0,.516,16.663a24.629,24.629,0,0,0,17.266-23.5",
    transform: "translate(660.623 612.377)",
    fill: "#004b94"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_142",
    "data-name": "Path 142",
    d: "M0,0-7.451,11.816l-5.507-3.472L-5.217-3.931l.036-.057C-1.889-9.208-4.087-15-12.52-20.32l-11.586-7.306,3.184-5.048,11.414,7.2c4.818,3.039,11.978,6.431,15.6.695,2.279-3.614.543-8.235-6.97-12.973L-1-37.827l-13.537-8.535,3.147-4.991L1.861-43l.288.181c12.259,7.891,13.821,14.568,9.227,21.852a10.345,10.345,0,0,1-12.393,3.89C4.857-10.244,2.776-4.021,0,0",
    transform: "translate(380.491 994.6)",
    fill: "#004b94"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_143",
    "data-name": "Path 143",
    d: "M0,0-2.488,5.5-8.417,2.813l2.488-5.5c3.634-8.03,1.648-15.478-6.32-19.086-7.658-3.465-14.527-.621-18.135,7.346l-3.243,7.165-.061-.028L-39.477,5.5l-5.866-2.656,21.164-46.757,5.867,2.656-6.6,14.577a16.609,16.609,0,0,1,15.065-.4C2.015-21.712,5.089-11.241,0,0",
    transform: "translate(439.941 1015.171)",
    fill: "#004b94"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_144",
    "data-name": "Path 144",
    d: "M0,0-11.438-3.4l-7.426,24.955C-22.4,33.443-31.744,38.446-43.7,34.888-55.724,31.311-60.874,22-57.336,10.1l9.107-30.61,6.24,1.856L-51.1,11.96c-2.513,8.447,1.021,14.876,9.079,17.274,7.994,2.378,14.4-1.091,16.917-9.54l9.108-30.608L1.682-5.654Z",
    transform: "translate(515.492 1013.811)",
    fill: "#004b94"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_145",
    "data-name": "Path 145",
    d: "M0,0-1.4,11.1c-1.55,12.309-9.95,18.769-22.327,17.21-12.445-1.568-19.046-9.916-17.5-22.227l3.253-25.831L-49.807-21.24l.738-5.853,18.3,2.305L-34.764,6.9c-1.1,8.745,3.435,14.509,11.776,15.561S-8.957,19.03-7.856,10.285l1.4-11.1Z",
    transform: "translate(573.228 1036.507)",
    fill: "#004b94"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_146",
    "data-name": "Path 146",
    d: "M0,0-8.613-7.021c-3.222,5.217-9,8.177-16.725,8.328-12.542.243-20.279-7.068-20.52-19.473l-.62-31.93,6.508-.127.62,31.931c.172,8.813,5.492,13.863,13.9,13.7,8.339-.161,13.39-5.414,13.22-14.226l-.62-31.931,6.508-.126.619,31.931a25.751,25.751,0,0,1-.624,6.251L3.5-4.679Z",
    transform: "translate(637.403 1066.72)",
    fill: "#004b94"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_147",
    "data-name": "Path 147",
    d: "M0,0-11.772,1.953-9.3,16.868l-6.421,1.065-5.225-31.5C-22.375-22.2-28.38-26.494-36.673-25.118S-49.14-17.827-47.7-9.133l1.41,8.494L-52.711.427l-1.407-8.494c-2.02-12.173,4.173-20.829,16.48-22.87,12.374-2.052,21.1,4.129,23.116,16.3l1.785,10.769L-.966-5.818Z",
    transform: "translate(706.47 1041.646)",
    fill: "#004b94"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_148",
    "data-name": "Path 148",
    d: "M0,0-6.188,2.014l-9.88-30.366c-3.817-11.734,1.075-21.239,13-25.12C8.8-57.331,18.281-52.5,22.1-40.77l2.79,8.576L18.7-30.182,15.91-38.756c-2.727-8.381-9.222-11.687-17.151-9.106-7.994,2.6-11.343,9.179-8.637,17.5Z",
    transform: "translate(734.455 1049.079)",
    fill: "#004b94"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_149",
    "data-name": "Path 149",
    d: "M0,0-10.773-2.727c-.717,6.089-4.7,11.211-11.643,14.611C-33.683,17.4-43.783,14.042-49.24,2.9l-14.045-28.68,5.845-2.864L-43.4.036c3.878,7.916,10.833,10.248,18.384,6.551,7.49-3.669,9.852-10.563,5.974-18.48l-14.045-28.68,5.847-2.864,14.044,28.682a25.777,25.777,0,0,1,2.074,5.93L1.2-5.721Z",
    transform: "translate(829.479 1009.406)",
    fill: "#004b94"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_150",
    "data-name": "Path 150",
    d: "M0,0-9.808,6.8,5.029,28.2C12.1,38.4,10.163,48.814-.09,55.923c-10.308,7.147-20.8,5.345-27.871-4.853l-18.2-26.247,5.348-3.708,18.2,26.246c5.022,7.244,12.25,8.5,19.161,3.713C3.4,46.322,4.7,39.151-.321,31.906L-18.519,5.66-3.361-4.849Z",
    transform: "translate(867.634 930.118)",
    fill: "#004b94"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoBlue);
export default __webpack_public_path__ + "static/media/logoBlue.29b27218a6f45cbfe0cc38ec85aca25a.svg";
export { ForwardRef as ReactComponent };